import React, { Component, createRef } from "react";
import "./cit-dashboard.styles.css";

import API from "../../api";

import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";

import { selectUserData } from "../../redux/user/user.selectors";
import { message, Row, Col, PageHeader, Select, List } from "antd";
import { setScreen } from "../../redux/commodity-intelegence-tower/commodity-intelegence-tower.actions";
import {
  selectCitData,
  selectPowerbiData,
} from "../../redux/commodity-intelegence-tower/commodity-intelegence-tower.selectors";
import { PowerBIEmbed } from "powerbi-client-react";
import { models } from "powerbi-client";

/**
 *
 * @classdesc The Buying reccomendation tab component.
 * @description Displays a table containing the daily output from the modal
 * @component
 */
class PowerBIDetails extends Component {
  state = {
    isSpinnerOnTable: true,
    reportId: "",
    reportToken: "",
  };

  /**
   * @function
   * @description Wait until the user logs in so that a valid access token is generated
   * to call the get api for daily recommentation data.
   */
  waitUntilLogin = () => {
    if (localStorage.getItem("accessToken") != null) {
      this.setState({ isSpinnerOnTable: true });
      API.get("/powerbi-token", {
        params: { report_id: this.props.powerbiData.report_id },
      }).then((response) => {
        console.log("token", response);
        if (response.data.data.ReportToken) {
          this.setState({
            reportId: response.data.data.ReportId,
            reportToken: response.data.data.ReportToken,
          });
        }
      });
      this.setState({
        isSpinnerOnTable: false,
      });
    } else {
      setTimeout(() => this.waitUntilLogin(), 100);
    }
  };

  componentDidMount() {
    this.waitUntilLogin();
  }

  render() {
    //#endregion
    const handleChange = (pagination, filters, sorter) => {
      // this.setState({ filteredInfo: filters });
    };
    return (
      <div
        className="cit-container"
        style={{ height: window.innerHeight - 83 }}
      >
        <div className="dashboard">
          <PageHeader
            onBack={() => this.props.setScreen(1)}
            title={this.props.citData.crop_name}
            className="cit-header"
            style={{
              background: "#4672ba",
            }}
          />
          <Row>
            <Col
              span={24}
              style={{
                maxHeight: "70vh",
                overflowY: "auto",
                background: "white",
              }}
            >
              {/* <embed
                width="100vh"
                height="600px"
                src="https://app.powerbi.com/reportEmbed?reportId=d6be5cf2-1f26-45aa-85d4-59b7a15730f3&autoAuth=true&ctid=622f8cde-07b5-4d16-ab2a-6dc0c3a66e35&groupId=bc0e1cce-097f-45f6-9216-bf3082be42d2"
                // src={this.props.powerbiData.link}
                style={{ border: "none", width: "100vh", maxHeight: "70vh" }}
              /> */}
              {this.state.reportId != "" && (
                <PowerBIEmbed
                  embedConfig={{
                    type: "report",
                    id: this.state.reportId,
                    embedUrl: undefined,
                    accessToken: this.state.reportToken,
                    tokenType: models.TokenType.Embed,
                    permissions: models.Permissions.All,
                    settings: {
                      panes: {
                        filters: { visible: true },
                        pageNavigation: { visible: true },
                      },
                      background: models.BackgroundType.Transparent,
                    },
                  }}
                  cssClassName="powerbi-embed"
                />
              )}
            </Col>
          </Row>
        </div>
      </div>
    );
  }
}

const mapStateToProps = createStructuredSelector({
  userData: selectUserData,
  citData: selectCitData,
  powerbiData: selectPowerbiData,
});

const mapDispatchToProps = (dispatch) => {
  return {
    setScreen: (data) => dispatch(setScreen(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PowerBIDetails);
